export default __webpack_public_path__ + "static/media/funmi.2726996b.jpg";